export enum JOB_TYPES {
    ONE_TIME = 'One-time',
    ONGOING = 'Ongoing'
}

export enum GUARD_ARMED_STATUS {
    ARMED = 'Armed',
    UNARMED = 'Unarmed'
}

export enum REPEAT_CYCLE {
    CUSTOM = 'custom',
    FORTNIGHTLY = 'fortnightly',
    MONTHLY = 'monthly',
    WEEKLY = 'weekly'
}

export enum REPEAT_CUSTOM_TYPE {
    MONTHLY = 'monthly',
    WEEKLY = 'weekly'
}

export enum REPEAT_FREQUENCIES {
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month'
}

export enum JOB_STATUSES {
    PENDING = 'pending', //Admin has not posted job to the guards
    ACCEPTED = 'accepted', //In app this will show as "pending"
    REJECTED = 'rejected',
    CONFIRMED = 'confirmed',
    COMPLETED = 'completed',
    CANCELLED = 'canceled'
}

export enum SHIFT_STATUSES {
    NOT_APPLIED = 'not_applied',
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    REJECTED = 'rejected',
    CANCELLED = 'canceled',
    CALLED_OFF = 'called off',
    SHIFT_CANCELLED = 'shift cancelled'
}
